import { useEffect } from "react";
import { io, type Socket } from "socket.io-client";
import { useQueryClient } from "@tanstack/react-query";
import { toastInfo } from "../stores/ui";

let socket: Socket | null = null;

export function useRealtime() {
  const queryClient = useQueryClient();
  useEffect(() => {
    socket = io({ withCredentials: true });
    const invalidate = () => {
      void queryClient.invalidateQueries();
    };
    socket.on("roster:updated", invalidate);
    socket.on("recruits:updated", invalidate);
    socket.on("activity:created", invalidate);
    socket.on("activity:updated", invalidate);
    socket.on("notification:new", (payload: { title?: string; body?: string }) => {
      invalidate();
      toastInfo(payload?.title ?? "New notification", payload?.body);
    });
    return () => {
      socket?.disconnect();
      socket = null;
    };
  }, [queryClient]);
}
